import React from "react";
import { View } from "tamagui";
import { Dimensions } from "react-native";
import { RouteCard } from "../../../../features/Routes/components/RouteCard";
import { EventImage } from "../../components/EventImage";
import { Event } from "../../../../types/event";

type EventDetailHeroProps = {
  route: Event["route"];
  eventType: Event["type"];
};

export const EventDetailHero = ({ route, eventType }: EventDetailHeroProps) => {
  const screenWidth = Dimensions.get("window").width;

  console.log("test");

  if (route?.image_url && route?.strava_id) {
    console.log("tt");
    return (
      <View w="100%">
        <View pos="relative" borderBottomWidth={1}>
          <View w={screenWidth} justifyContent="center" alignItems="center">
            <RouteCard
              image_url={route.image_url}
              strava_id={route.strava_id}
            />
          </View>
        </View>
      </View>
    );
  }

  console.log("eventType", eventType);

  if (eventType === "ClubRide") return null;

  console.log("aahh");

  return (
    <View
      flex={1}
      bg="$brandParchment"
      w="100%"
      justifyContent="center"
      alignItems="center"
    >
      <EventImage width={140} height={140} type={eventType ?? "PopUp"} />
    </View>
  );
};
